import { z } from "zod/v4"
import type { DocumentSnapshotLike } from "../firestore"
import { GlobalNgWordId } from "../id"
import { CreatedAt, UpdatedAt } from "./system"

export const GlobalNgWordDocumentMeta = z.object({
  word: z.string().describe("NGワード"),
  is_regex: z.boolean().describe("正規表現かどうか trueの場合は正規表現として扱われる falseの場合はワードを部分一致で扱われる"),
})

export type GlobalNgWordDocumentMeta = z.infer<typeof GlobalNgWordDocumentMeta>

export const GlobalNgWordDocumentBody = GlobalNgWordDocumentMeta.extend({
  created_at: CreatedAt,
  updated_at: UpdatedAt,
})

export type GlobalNgWordDocumentBody = z.infer<typeof GlobalNgWordDocumentBody>

export type GlobalNgWordDocument = GlobalNgWordDocumentBody & {
  id: GlobalNgWordId
}

export class GlobalNgWordDocuments {

  static toDocumentData(doc: GlobalNgWordDocument): object {
    return {
      ...doc,
      // id は document path に入るので入れない
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): GlobalNgWordDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: GlobalNgWordId(doc.id),
      word: data["word"],
      is_regex: data["is_regex"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}

export const CreateOrUpdateGlobalNgWordRequest = z.object({
  word: z.string().min(1),
  isRegex: z.boolean()
})

export type CreateOrUpdateGlobalNgWordRequest = z.infer<typeof CreateOrUpdateGlobalNgWordRequest>

/** NG判定ログの発生エリア kind → 日本語ラベルのマッピング */
export const NgWordCheckAreaKind = {
  "space-name": "スペース名",
  "profile": "プロフィール",
  "story": "ストーリー",
  "live-tag": "ライブタグ",
  "live-comment": "ライブコメント",
  "free-board": "フリーボード",
  "selection": "抽選",
  "selection-entry": "抽選エントリー",
  "voice-title": "ボイスタイトル",
} as const satisfies Record<string, string>

export type NgWordCheckAreaKindType = keyof typeof NgWordCheckAreaKind
